module.exports = __webpack_public_path__ + "img/公告.337beca9.png";